import { colors } from '../commons/colors';
export var colorVars = {
  mainColor: colors.primary,
  secondaryColor: colors.secondary,
  terciaryColor: colors.terciary
};